<template>
  <div class="lavorazioni-sub">
    <common-hero :background="pageApiData.cover">
      <span class="common-hero__processing-order">{{ pageApiData.order }}</span>
      <h1 v-html="pageApiData.title"></h1>
      <h2 v-html="pageApiData.description"></h2>
      <div
        v-if="pageApiData.content !== ''"
        v-html="pageApiData.content"
        class="common-hero__page-content">
      </div>
    </common-hero>

    <zmm-video v-if="pageApiData.video" :video-id="pageApiData.video" />

    <section class="lavorazioni-sub-tech-details">
      <div class="default-container">
        <ul>
          <li v-for="(detail, index) of pageApiData.techs"
          class="lavorazioni-sub-tech-details__single"
          :key="index">
            <h3 class="lavorazioni-sub-tech-details__single__title">{{ detail.title }}</h3>

            <div
              class="lavorazioni-sub-tech-details__single__area"
              v-html="detail.content">
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section v-if="pageApiData.gallery" class="lavorazioni-sub-tech-details" style="padding-top:0;">
      <zmm-gallery :gallery-id="pageApiData.gallery" :lang="lang"/>
    </section>

    <div class="sticky-prev-next-menu">
      <div class="default-container">
        <div class="sticky-prev-next-menu__links-container">
          <router-link :to="{ name: `${lang}-lavorazioni` }">
            <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="SIMBOLI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="sticky-navigation-bar" transform="translate(-281.000000, -33.000000)" fill="#EFEFF1">
                      <g id="Group">
                          <g transform="translate(281.000000, 33.000000)">
                              <rect id="Rectangle" x="0" y="0" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-3" x="0" y="6" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-6" x="0" y="12" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy" x="6" y="0" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-4" x="6" y="6" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-7" x="6" y="12" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-2" x="12" y="0" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-5" x="12" y="6" width="3" height="3"></rect>
                              <rect id="Rectangle-Copy-8" x="12" y="12" width="3" height="3"></rect>
                          </g>
                      </g>
                  </g>
              </g>
            </svg>
          </router-link>
          <ul>
            <li>
              <router-link
                :to="{ name: `${lang}-lavorazioni-sub`, params: { type: previous && previous.slug } }"
                class="sticky-prev-next-menu__previous">
                {{ $t('ctaPrevious') }}
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: `${lang}-lavorazioni-sub`, params: { type: next && next.slug } }"
                class="sticky-prev-next-menu__next">
                {{ $t('ctaNext') }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import lang from '@/views/mixins/lang'
import { mapGetters, mapActions } from 'vuex'
import store from '../store'
import { SET_GLOBAL_LOADING } from '../store/mutation-types'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import ZmmVideo from '@/components/ZmmVideo'
import ZmmGallery from '@/components/ZmmGallery'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    CommonHero,
    ZmmVideo,
    ZmmGallery
  },
  computed: {
    ...mapGetters([
      'viewport',
      'processingsExcerpts'
    ]),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    processingsQuery: {
      get () {
        return { pageName: 'processings', lang: this.lang || 'en' }
      }
    },
    processingsList: {
      get () {
        return this.page(this.lang, 'processings').sections || []
      }
    },
    previous: {
      get () {
        const prevIndex = this.processingsList.indexOf(this.pageApiData.slug) - 1
        const prevSlug = this.processingsList[prevIndex < 0 ? this.processingsList.length - 1 : prevIndex]
        if (typeof prevSlug !== 'undefined') return _.find(this.processingsExcerpts(this.lang), ({ slug }) => slug === prevSlug)
      }
    },
    next: {
      get () {
        const nextIndex = this.processingsList.indexOf(this.pageApiData.slug) + 1
        const nextSlug = this.processingsList[nextIndex >= this.processingsList.length ? 0 : nextIndex]
        if (typeof nextSlug !== 'undefined') return _.find(this.processingsExcerpts(this.lang), ({ slug }) => slug === nextSlug)
      }
    }
  },
  async beforeRouteUpdate (to, from, next) {
    // set env to loading
    store.commit(SET_GLOBAL_LOADING, true)

    // extract language
    const lang = _.split(to.name, '-')[0] || 'en'

    // start loading
    await store.dispatch('loadPageData', { pageName: to.meta.pageName, lang, type: to.params.type })

    store.commit(SET_GLOBAL_LOADING, false)

    if (to.hash) this.$_scrollToHash(to.hash)
    next()
  },
  methods: {
    ...mapActions([
      'loadProcessingsExcerpts'
    ]),
    $_loadProcessings (query) {
      this.loadPageData(query)
    }
  },
  watch: {
    processingsQuery: {
      handler (query) {
        this.$_loadProcessings(query)
      },
      immediate: true,
      deep: true
    },
    processingsList: {
      handler (list) {
        store.commit(SET_GLOBAL_LOADING, true)
        this.loadProcessingsExcerpts({
          lang: this.lang,
          filter: list
        })
        store.commit(SET_GLOBAL_LOADING, false)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .sticky-prev-next-menu{
    width: 100%;
    position: sticky;
    bottom: 0;
    background-color: #000;
    z-index: 10;
    .sticky-prev-next-menu__links-container{
      width: 100%; display: flex; flex-wrap: nowrap;
      justify-content: space-between;
      height: 80px; align-items: center;
      ul{
        margin: 0; padding: 0;
        display: flex;
        li{
          margin-left: 25px;
          a{
            @include size-14-pixel(#EFEFF1);
            letter-spacing: .15rem;
            font-family: 'Roboto', sans-serif;
            font-weight: 500; line-height: 1.2;
            text-transform: uppercase;
            text-decoration: none;
            padding: 10px 25px 10px 0;
            display: inline-block;
            transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
          }
          .sticky-prev-next-menu__previous{
            color: #efefff;
            border-right: 1px solid #4A4A4A;
          }

          a:hover, .sticky-prev-next-menu__previous:hover{
            color: #679196;
          }
        }
      }
    }
  }

  .lavorazioni-sub-content{
    background-color: #1d1d1b;
    padding: 8rem 0 4rem;

    @media #{$medium_mq} {
       padding: 10rem 0 4rem;
    }

    @media #{$large_mq} {
       padding: 14rem 0 4rem;
    }

    p{
      @include title-72-pixel(#9B9B9B);
      padding: 2rem 0;
      margin: 0;

      @media #{$medium_mq} {
        padding: 3rem 0;
        padding-left: 10%;
      }

      @media #{$xlarge_mq} {
        padding-left: 10%;
      }

    }

    p:first-child{
      font-size: 3rem;
      line-height: 1.4;
      color: #EFEFF1;
      font-weight: 100;
      padding-top: .8rem;
      @media #{$medium_mq} {
        padding-left: 0;
      }

      @media #{$xlarge_mq} {
        font-size: 4.8rem;
        padding-left: 0;
      }
    }

    strong{
      color: #5530FF;
      font-weight: 100;
    }

  }

  .lavorazioni-sub-tech-details{
    padding: 1.5rem 0;
    @media #{$medium_mq} {
      padding: 3rem 0;
    }
    @media #{$large_mq} {
      padding: 3.5rem 0;
    }
    @media #{$xlarge_mq} {
      padding: 4rem 0;
    }
    @media #{$xxlarge_mq} {
      padding: 5rem 0;
    }
    background-color: #1d1d1b;
    ul, li{
      padding: 0; margin: 0; list-style: none; list-style-type: none;
    }
    .lavorazioni-sub-tech-details__single{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: baseline;
      margin-bottom: 3rem;

      @media #{$medium_mq} {
        flex-wrap: nowrap;
      }
      .lavorazioni-sub-tech-details__single__title{
        @include size-16-pixel(#EFEFF1);
        letter-spacing: .2rem;
        font-family: 'Roboto', sans-serif;
        font-weight: 500; line-height: 1.2;
        text-transform: uppercase;
        margin: 0; padding: 8px 45px 0 0;
        margin-bottom: 30px;
        width: 100%;
        @media #{$medium_mq} {
          width: 210px;
          margin-bottom: 0;
        }
      }
      .lavorazioni-sub-tech-details__single__area{
        padding: 8px 0 8px 60px;
        width: 100%;
        border-left: 1px solid #9B9B9B;
        @media #{$medium_mq} {
          width: auto;
        }
        li{
          @include size-18-pixel(#9B9B9B);
          letter-spacing: .1rem;
          font-family: 'Roboto', sans-serif;
          font-weight: 300; line-height: 1.4;
          margin-bottom: 2rem;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .richiesta-informazioni{
    background-color: #1d1d1b;
    padding: 6rem 0 8rem;
    text-align: center;
    border-top: 1px solid #4A4A4A;
    border-bottom: 1px solid #4A4A4A;

    @media #{$large_mq} {
      padding: 8rem 0 10rem;
    }

    p{
      font-size: 3rem;
      line-height: 1.4;
      color: #EFEFF1;
      font-weight: 100;
      margin-bottom: 4rem;

      @media #{$medium_mq} {
        text-align: center;
        max-width: 500px;
        margin: 2rem auto 5rem;
      }
      @media #{$xlarge_mq} {
        font-size: 4.2rem;
        max-width: 700px;
      }
    }
    button{
      font-size: 1.8rem;
      border: 0;
      background-color: #679196;
      color: #EFEFF1;
      border-radius: 28px;
      padding: 1.6rem 1.8rem 2rem 3.2rem;
      display: inline-block;
      width: 100%;
      cursor: pointer;
      margin-top: 1rem;
      font-weight: 300;
      letter-spacing: .15rem;

      @media #{$medium_mq} {
        width: 312px;
      }
    }
    img{
      margin-left: 1rem;
      vertical-align: middle;
      top: -3px;
    }
  }

  .lavorazioni-sub .common-hero h2{
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    margin-bottom: 0;
  }

  .lavorazioni-sub .common-hero p{
    @include size-18-pixel(#EFEFF1);
    line-height: 1.8;
    margin-bottom: 0;
  }

</style>
